module.exports = __webpack_public_path__ + "static/media/wan_lend.b042d558.svg";